import * as React from "react";

const SvgCheckMark = () => (
    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

const Checkbox = ({ id, checked, text, onChange, useSvg }) => {
    return (
        <label style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
            <input type="checkbox" id={id} name={id} checked={checked} onChange={onChange} style={{ display: 'none' }} />
                {checked && useSvg ? <SvgCheckMark /> : <div style={{ width: '24px', height: '24px', backgroundColor: checked ? 'green' : 'transparent', border: '1px solid black' }} />}
            <span style={{ marginLeft: '8px' }}>{text}</span>
        </label>
    );
};

export default Checkbox;